import { application } from "@controllers/application";
import { Turbo } from "@hotwired/turbo-rails";
import "@lib/preline_loader";

import DatepickerController from "@controllers/common/datepicker/datepicker";
import CardController from "@controllers/preline/card/card";
import FileUploadController from "@controllers/preline/file_upload/file_upload";
import FileUploadInputController from "@controllers/preline/file_upload/file_upload_input";
import ReadMoreController from "@controllers/preline/read_more/read_more";
import ShareLinkController from "@controllers/preline/share_link/share_link";
import MemorySubmitController from "@controllers/preline/memory/memory-submit";
import MemorySelectController from "@controllers/preline/memory/memory-select";
import ToggleVisibilityController from "@controllers/preline/toggle-visibility/toggle-visibility";
import PartialNavigationController from "@controllers/preline/partial_navigation/partial_navigation";
import CarouselController from "@controllers/preline/carousel/carousel";
import CharityController from "@controllers/tributes/charity/charity";
import OnboardingServiceDetailsController from "@controllers/tributes/onboarding_service_details";
import ImageSkeletonController from "@controllers/preline/image_skeleton/image_skeleton";
import TributeOnboardingModalController from "@controllers/preline/tribute_onboarding_modal/tribute_onboarding_modal";
import ButtonController from "@controllers/preline/button/button";
import ModalController from "@controllers/preline/modal/modal";

application.register("datepicker", DatepickerController);
application.register("card", CardController);
application.register("file_upload", FileUploadController);
application.register("file_upload_input", FileUploadInputController);
application.register("read_more", ReadMoreController);
application.register("share_link", ShareLinkController);
application.register("memory-submit", MemorySubmitController);
application.register("memory-select", MemorySelectController);
application.register("toggle-visibility", ToggleVisibilityController);
application.register("partial_navigation", PartialNavigationController);
application.register("carousel", CarouselController);
application.register("charity", CharityController);
application.register("image_skeleton", ImageSkeletonController);
application.register("tribute_onboarding_modal", TributeOnboardingModalController);
application.register("button", ButtonController);
application.register("modal", ModalController);
application.register("onboarding_service_details", OnboardingServiceDetailsController);

Turbo.session.drive = false;

document.documentElement.addEventListener("turbo:frame-load", () => {
  window.HSStaticMethods.autoInit();
});
